import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afcf4c1c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=afcf4c1c&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=afcf4c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcf4c1c",
  null
  
)

export default component.exports